"use client";
import Image from 'next/image';
import Link from 'next/link';
import { RxInstagramLogo } from "react-icons/rx";

const navLinks = [
    { href: '/accompagnement', label: 'Accompagnement' },
    { href: '/rendez-vous-et-tarifs', label: 'Rendez-vous et tarifs' },
    { href: '/articles', label: 'Articles' },
    { href: '/a-propos', label: 'A propos' },
    { href: '/contactez-moi', label: 'Contactez-moi' },
];

const specialties = [
    { href: '/fertilite', label: 'Fertilité' },
    { href: '/troubles-hormonaux', label: 'Troubles hormonaux' },
    { href: '/perte-de-poids', label: 'Perte de poids' },
];

const Footer = () => {
    return (
        <footer className="bg-[#F0F2EE]">
            {/* Contenu principal */}
            <div className="max-w-7xl mx-auto px-6 lg:px-8 pt-12 pb-8">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">

                    {/* Colonne 1 — Logo + disclaimer */}
                    <div className="lg:col-span-1">
                        <Link href="/" aria-label="Retour à la page d'accueil" className="inline-block mb-4 transition-transform duration-200 hover:scale-105">
                            <Image
                                src="/assets/logohormelys1.webp"
                                alt="Hormelys — cabinet de naturopathie"
                                width={180}
                                height={90}
                            />
                        </Link>
                        <p className="text-xs text-gray-600 leading-relaxed">
                            Les informations de ce site relèvent de la naturopathie, une approche de santé globale et durable, qui ne se substitue en aucun cas à un avis médical. Ne modifiez ou n&apos;arrêtez jamais un traitement sans l&apos;avis de votre médecin.
                        </p>
                    </div>

                    {/* Colonne 2 — Navigation */}
                    <div>
                        <h3 className="text-sm font-semibold text-[#2C6E63] uppercase tracking-wider mb-4">Navigation</h3>
                        <ul className="space-y-2.5">
                            {navLinks.map((link) => (
                                <li key={link.href}>
                                    <Link href={link.href} className="text-sm text-gray-600 hover:text-[#2C6E63] transition-colors duration-200">
                                        {link.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Colonne 3 — Spécialisations */}
                    <div>
                        <h3 className="text-sm font-semibold text-[#2C6E63] uppercase tracking-wider mb-4">Spécialisations</h3>
                        <ul className="space-y-2.5">
                            {specialties.map((link) => (
                                <li key={link.href}>
                                    <Link href={link.href} className="text-sm text-gray-600 hover:text-[#2C6E63] transition-colors duration-200">
                                        {link.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Colonne 4 — Contact */}
                    <div>
                        <h3 className="text-sm font-semibold text-[#2C6E63] uppercase tracking-wider mb-4">Contact</h3>
                        <ul className="space-y-3">
                            <li>
                                <Link href="mailto:nathalia.laffont@gmail.com" className="text-sm text-gray-600 hover:text-[#2C6E63] transition-colors duration-200" aria-label="Envoyer un mail à contact@hormelys.com">
                                    contact@hormelys.com
                                </Link>
                            </li>
                            <li>
                                <Link href="tel:+33685683059" className="text-sm text-gray-600 hover:text-[#2C6E63] transition-colors duration-200" aria-label="Appeler le 06 85 68 30 59">
                                    06 85 68 30 59
                                </Link>
                            </li>
                            <li className="text-sm text-gray-600">
                                <p>Pôle Santé de Gignac</p>
                                <p>280 Avenue de Lodève</p>
                                <p>34150 Gignac</p>
                            </li>
                            <li className="pt-1">
                                <Link
                                    href="https://www.instagram.com/nathalia_energie.vitalite?igsh=OTdhY3R0eHl5YTlm"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label="Suivez-moi sur Instagram"
                                    className="inline-flex items-center gap-2 text-sm text-gray-600 hover:text-[#2C6E63] transition-colors duration-200"
                                >
                                    <RxInstagramLogo className="w-5 h-5" />
                                    <span>Instagram</span>
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            {/* Barre basse */}
            <div className="border-t border-[#D4DDD1]">
                <div className="max-w-7xl mx-auto px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
                    <p className="text-xs text-gray-600">
                        &copy; 2024-2026 Nathalia Laffont &middot; Reproduction interdite
                    </p>
                    <div className="flex items-center gap-4 text-xs text-gray-600">
                        <Link href="/mentions-legales" className="hover:text-[#2C6E63] transition-colors duration-200">
                            Mentions légales
                        </Link>
                        <span>&middot;</span>
                        <Link href="/politique-de-confidentialite" className="hover:text-[#2C6E63] transition-colors duration-200">
                            Politique de confidentialité
                        </Link>
                        <span>&middot;</span>
                        <span>
                            Site créé par{' '}
                            <Link href="https://dlwebcreation.com" target="_blank" rel="noopener noreferrer" className="text-[#2C6E63] hover:underline">
                                dlwebcreation
                            </Link>
                        </span>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
